import { Controller } from '@hotwired/stimulus';
import RailsEnv from '@frontend/app/features/RailsEnv';

export default class extends Controller {
  connect() {
    this.element.addEventListener('lazybeforeunveil', this.handleUnveil.bind(this));
    this.element.classList.add('lazyload');

    if(RailsEnv.isTest()) { // Loading content immediately in Tests
      this.activateLazyPartialController();
    }
  }

  handleUnveil(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.activateLazyPartialController();
  }

  activateLazyPartialController() {
    this.element.dataset.controller = `${this.element.dataset.controller} lazy-partial`;
  }
}

